// The MainNav is cached, which means SilverStripe cannot set the active link, this script fixes
// this issue by setting the active link.

(function ($) {
  const pathComponents = window.location.pathname
    .split("/")
    .filter(function (p) {
      return p;
    });

  let classes = "active";
  if (pathComponents.length === 1) {
    classes += " current";
  } else {
    classes += " section";

    if (pathComponents.length >= 2) {
      const childElem = $(".main-subnav")
        .find('[href^="' + window.location.pathname + '"]')
        .eq(0)
        .closest("li");

      childElem.removeClass("link");
      childElem.addClass("current");
    }
  }

  $(".main-nav")
    .find('[href^="/' + pathComponents[0] + '"]')
    .each(function () {
      // We need to ensure we only modify top level menu and not sub menu
      if ($(this).parent().hasClass("mn-link-container")) {
        const parentElem = $(this).closest("li");
        parentElem.removeClass("link");
        parentElem.addClass(classes);
      }
    });
})(jQuery);
